// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vyR5","placeholdersHeader":"styles_placeholdersHeader__1222r","editorStyle":"styles_editorStyle__2z0ei","placeholdersBox":"styles_placeholdersBox__2wkh0"};